import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "flex flex-wrap items-center gap-1",
  "data-testid": "professional-tags"
}

import { computed } from 'vue'

import LabelBadge from '@/components/designSystem/Badges/LabelBadge.vue'
import type { ReviewQueueTag } from '@/types/professional-documents.types'

import { REVIEW_TAG_CONFIG, REVIEW_TAG_ORDER } from '../constants'


export default /*#__PURE__*/_defineComponent({
  __name: 'ProfessionalTags',
  props: {
    tags: {}
  },
  setup(__props: any) {

const props = __props;



/** Ordem fixa (Novo → Urgente → Bloqueia alocação → Concluído), independente da do backend. */
const ordered = computed(() => REVIEW_TAG_ORDER.filter((tag) => props.tags.includes(tag)))

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(ordered.value, (tag) => {
      return (_openBlock(), _createBlock(LabelBadge, {
        key: tag,
        label: _unref(REVIEW_TAG_CONFIG)[tag].label,
        color: _unref(REVIEW_TAG_CONFIG)[tag].color,
        icon: _unref(REVIEW_TAG_CONFIG)[tag].icon,
        size: "small"
      }, null, 8, ["label", "color", "icon"]))
    }), 128))
  ]))
}
}

})